module.exports = __webpack_public_path__ + "img/irn.23e0f96c.svg";